export default class SysNewsController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/sysNews/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/update', 'post', params, axiosOption, httpOption);
  }

  static updateUpFlag (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/updateUpFlag', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/delete', 'post', params, axiosOption, httpOption);
  }

  static startOnlyFlowNewsAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/startOnly/flowNewsAudit', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyFlowNewsAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/startWithBusinessKey/flowNewsAudit', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskFlowNewsAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/startAndTakeUserTask/flowNewsAudit', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftFlowNewsAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/startAndSaveDraft/flowNewsAudit', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskFlowNewsAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/submitUserTask/flowNewsAudit', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataFlowNewsAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/viewTaskBusinessData/flowNewsAudit', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataFlowNewsAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/viewHistoricTaskBusinessData/flowNewsAudit', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderFlowNewsAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/sysNews/listWorkOrder/flowNewsAudit', 'post', params, axiosOption, httpOption);
  }
}
